import styled from 'styled-components';

export const ContainerTemplate = styled.div``;

export default ContainerTemplate;
